export default {
  home: 'Home',
  login: 'Login',
  designate: 'Name',
  download_center: 'Download center',
  logout: 'Logout',
  title: 'Remote Debugging System',
  language: 'Language',
  chinese: 'cn_ZH',
  english: 'en_US',
  beginTime: 'Begin Time',
  endTime: 'End Time',
  account_number: 'Input the account number',
  projectNameTip: 'Input project name',
  psnCode: ' Input PSN code',
  to: 'to',
  commissionDetailTitle: 'Project Name - Controller PSN Commissioning Record',
  number: 'ID',
  time: 'Time',
  account: 'Account',
  upgradeFile: 'Upgrade file',
  printType: 'Print type',
  all: 'All',
  fireInformation: 'Fire information',
  faultInformation: 'Fault information',
  linkageInformation: 'Linkage information',
  feedbackInformation: 'Feedback information',
  superviseInformation: 'Supervision information',
  operatorInformation: 'Operator information',
  otherInformation: 'Other information',
  projectName: 'Project Name',
  agencyName: 'Dealer',
  psn: 'PSN',
  fieldStaffName: 'Name of on-site personnel',
  fieldStaffPhone: 'Phone of on-site personnel',
  fieldStaffJob: 'Job of on-site personnel',
  operation: 'Operation',
  detail: 'Detail',
  content: 'content',
  queryButton: 'Query',
  saveButton:'save',
  systemSetting: 'System Setting',
  boardInformation: 'Board Information',
  fieldComponent: 'Field Component',
  boardType: 'Board type',
  boardNumber: 'Board number',
  version: 'Software version',
  psn1: 'PSN',
  loopNumber: 'Loop number',
  loopboard:'Loop board',
  multiline:'Multiline',
  busline:'Busline',
  gasExtinguishing:'Gas extinguishing',
  broadcast:'Broadcast',
  eventRecord:'Event record',
  crt:'crt',
  gateway:'gateway',
  gprs:'GRPS',
  wifi:'WIFI',
  nodata:'No data available',
  serial:'Serial',
  interfaceCard:'InterfaceCard',
  loopNo: 'loopNo',
  loopNum:'Loop  num',
  loop: 'Loop',
  devType: 'devType',
  num: 'num',
  total: 'Total',
  loginName: 'Login Name',
  name: 'Name',
  email: 'Email',
  orgNames: 'Agency',
  phone: 'Phone',
  oldPwd: 'Old Password',
  newPwd: 'New Password',
  confirmPwd: 'Confirm Password',
  role: 'Role',
  edit: 'Edit',
  editPassword: 'Edit Password',
  allow: 'Allow',
  disable: "Disable",
  machineNo: 'Machine No',
  panelNumber: 'Panel number',
  soundAndLightStart: 'Sound and light start',
  soundAndLightStop: 'Sound and light stop',
  silencing: 'Silencer',
  reset: 'Reset',
  proofreading: 'Calibration time',
  inspect: 'Inspect',
  close: 'Close',
  open: 'Open',
  realTimeValue: 'Real Time Value',
  rangeValue: 'Range Value',
  discNumber: 'Disc Number',
  value: 'Value',
  componentType: 'Component type',
  quantity: 'Quantity',
  model: 'Model',
  operationMode: 'OperationMode',
  foundationType: 'Foundation type',
  customerType: 'Customer type',
  manual: 'Manual',
  auto: 'Automatic',
  enable: 'Enable',
  panelTime: 'Panel time',
  jbf: 'JBF',
  detailed: 'Detailed',
  circuitBoardNumber: 'Circuit Board Number',
  codeNo: 'Component number',
  addressNumber: 'Address number',
  singleProgramming: 'Single linkage programming',
  totalLinkageProgramming: 'Total linkage programming',
  singleAnnotation: 'Single annotation',
  allAnnotation: 'Total annotation',
  sendToControllerProgress: 'Send To Controller Progress',
  controllerUploadProgress:'Controller Upload Progress',
  localUpload: 'Local Upload',
  panelUpload: 'Read all linkage programming',
  readAllHistory:'Read all history',
  notes:'Read all comments',
  fileDownload: 'File download',
  configDownload: 'Config download',
  startupTime: 'startup time',
  actionTime: 'action time',
  logicalExpression: 'Logical expression',
  uploadFromController: 'Upload From Controller',
  export: 'Export',
  equipmentType: 'Equipment Type',
  address: 'Address',
  event: 'Event',
  annotation: 'annotation',
  analog: 'Analog',
  addressTip: 'Input address',
  noteTip: 'Input note',
  localAddress: 'Local address',
  networkingMode: 'Networking mode',
  selctNetworkMode: 'Please select networking mode',
  receiveFire: 'Receive fire',
  receiveLinkage: 'Receive linkage',
  receiveFault: 'Receive fault',
  networkController: 'Network Controller',
  sendNeedRegistPanel: 'Send need regist panel',
  panelPSN: 'Panel PSN',
  panelType: 'Panel type',
  panelAnnotation: 'Panel annotation',
  panelVersion: 'Panel Version',
  siteInitiation: 'Site Initiation',
  siteEnd: 'Site End',
  analogAlarm: 'Analog Alarm',
  set: 'Set',
  componentNumber: 'Component number',
  startUp: 'Start Up',
  stop: 'Stop',
  autoRegister: 'Auto Register',
  manualRegister: 'Manual Register',
  loopAutoRegister: 'Loop Auto Register',
  loopManualRegister: 'Loop Manual Register',
  startDebugging: 'Start debugging',
  waitingForConnection: 'Waiting for connection',
  dynamicPassword: 'Dynamic password',
  fire: 'Fire',
  fault: 'Fault',
  supervision: 'Supervision',
  feedback: 'feedback',
  shield: 'Shield',
  relieve: 'Relieve',
  printerSwitch: 'Printer switch',
  printSpeed: 'Print speed',
  startAddress: 'Start address',
  endAddress: 'End address',
  fast: 'Fast',
  slow: 'Slow',
  onlyAdd: 'Keep the original registration information and only add',
  descr: 'Annotation information',
  delete: 'delete',
  download: 'download',
  save: 'save',
  trialDays: 'Trial days',
  remainingDays: 'Remaining days',
  setTimes: 'Set times',
  serialNumber: 'Serial number',
  state: 'State',
  type: 'Type',
  recentQuery: 'Recent query',
  powerSupplyVoltage: 'Power supply voltage',
  input: 'Input',
  output: 'Output',
  backupPower: 'Backup power',
  confirm: 'Confirm',
  cancel: 'Cancel',
  backgroundCurrent: 'Background current',
  stateCurrent: 'State current',
  success:'success',
  nostart:'not started',
  processing: 'processing',
  completed: 'completed',
  statType: 'Event type',
  fail:'fail',
  "sidebar": {
    "monitor": 'Monitor',
    "query": 'Query',
    "test": 'Test',
    "setting": 'Setting',
    "install": 'Install',
    "manage": 'Manage'
  },
  "manage": {
    "account": 'Account management',
    "standardItem": 'Standard item management',
    "debugRecord": 'Debug record',
    "authority": 'Authority management',
    "panelFunction": 'Panel function',
    "archive": 'Project archive',
    "beginDebug":'Begin debug'
  },
  "system": {
    "unitTest": 'Unit Test',
    "password": 'Password',
    "operationMode": 'Operation Mode',
    "cleaningTreatment": 'Cleaning Treatment',
    "networkController": 'Network Controller',
    "language": 'Language'
  },
  "install": {
    "registrationOfComponent": 'Registration of Component',
    "analogAlarm": 'Analog Alarm',
    "fixedPointAddressing": 'Fixed-point addressing',
    "remoteUpgrade": 'Remote upgrade'
  },
  "setting": {
    "printer": 'Set printer',
    "manualStartStop": 'Set manual start and stop equipment',
    "componentShielding": 'Set Component shield'
  },
  "test": {
    "simulationCurve": 'Detector simulation curve',
    "statusBrowsing": 'Loop status browse',
    "dataQuery": 'Component data query',
    "typeStatus": 'Component type status',
    "statusSignalValue": 'Component state signal value',
    "authorization": 'Authorization',
    "operatingVoltage": 'Operating Voltage'
  },
  "query": {
    "registeredAddress": 'Registered address',
    "linkageProgramming": 'Linkage programming',
    "historyRecord": 'History record',
    "unitBoardInformation": 'Unit board information',
    "annotationInformation": 'Annotation information',
    "unitConfiguration": 'System unit configuration',
    "networkConfiguration": 'Network configuration',
    "authorizationManagement": 'Authorization management'
  }
}
